module.exports = __webpack_public_path__ + "static/media/facebook-f-brands.53757d93.svg";